const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-6.25 -16.261 50.662 36.697",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Outlines",
    transform: "matrix(1, 0, 0, 1, -11, -29.00001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10 47 L 10 44 C 10 42.895 10.895 42 12 42 C 13.105 42 14 42.895 14 44 L 14 47",
    style: {
      fill: "rgb(11, 190, 238)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15 47 L 15 43 C 15 41.895 15.895 41 17 41 C 18.105 41 19 41.895 19 43 L 19 47",
    style: {
      fill: "rgb(246, 199, 86)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20 47 L 20 40 C 20 38.895 20.895 38 22 38 C 23.105 38 24 38.895 24 40 L 24 47",
    style: {
      fill: "rgb(55, 203, 161)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25 47 L 25 34 C 25 32.895 25.895 32 27 32 C 28.105 32 29 32.895 29 34 L 29 47",
    style: {
      fill: "rgb(11, 190, 238)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30 47 L 30 36 C 30 34.895 30.895 34 32 34 C 33.105 34 34 34.895 34 36 L 34 47",
    style: {
      fill: "rgb(246, 199, 86)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 35 47 L 35 25 C 35 23.895 35.895 23 37 23 C 38.105 23 39 23.895 39 25 L 39 47",
    style: {
      fill: "rgb(55, 203, 161)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 40 47 L 40 28 C 40 26.895 40.895 26 42 26 C 43.105 26 44 26.895 44 28 L 44 47",
    style: {
      fill: "rgb(11, 190, 238)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 47 L 45 19 C 45 17.895 45.895 17 47 17 C 48.105 17 49 17.895 49 19 L 49 47",
    style: {
      fill: "rgb(246, 199, 86)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50 47 L 50 22 C 50 20.895 50.895 20 52 20 C 53.105 20 54 20.895 54 22 L 54 47",
    style: {
      fill: "rgb(55, 203, 161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lines",
    transform: "matrix(1, 0, 0, 1, -11, -28.000008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54,46H9V13a1,1,0,0,0-1-1H6a1,1,0,0,0,0,2H7V29H6a1,1,0,0,0,0,2H7V46H6a1,1,0,0,0,0,2H54a1,1,0,0,0,0-2Z",
    style: {
      fill: "rgb(158, 130, 236)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.3db7e3fa9804d5e4db58e52aa9a6c9a2.svg";
export { ForwardRef as ReactComponent };